/* eslint-disable @typescript-eslint/prefer-optional-chain */
import React, { useEffect, useRef, useState } from 'react';
import moment from 'moment';
import Filter from '@/pages/dashboard/components/NewFilter';
import { setBtnPointLog } from "@/pages/dashboard/utils/utils";
import {  getLocale, useSelector } from 'umi';
import DateComparesionExralFilter from './dateComparesionExralFilter';
import { renderMetric } from './filterList';
import { mobileDateComparisonDefaultSelector, casualDateComparisonDefaultSelector } from './_constant';
import { useFilterData } from './hooks';
import { getDateDefault } from '../../utils/dateUtils';
import { useFrontMetricsOverride } from '@/pages/dashboard/hooks/useFrontMetricsList';

/**
 *
 * @param props
 * @param props:filterConfirm 筛选器确认函数
 * @param props:filterReset 筛选器重置函数
 * @param props:setFilterLoading 筛选器loading设置，透传到筛选器组件内部，获取到筛选器列表时区等数据之后，设置为false，测试才可进行页面和组件中的接口调用
 * @param props:filterInit 初始化函数，会向外部传递初始化后的筛选器值
 * @returns
 */

// 筛选器路径
const FILTER_PATH = 'comparisonAnalysis/eventComparison';

const MobileEventComparisonFilter = (props: any) => {
  const { filterConfirm, filterReset, buttonLogConfig, setFilterLoading, filterInit, path = FILTER_PATH, openSticky = false,
    children, isHaveFilterSave, timeZone = 0, config } = props;
  const [isReseted, setIsReseted] = useState<boolean>(false); // 是否重置过
  const { gameConfig, currentGame, metricsInfo } = useSelector((state: any) => ({
    gameConfig: state?.dashboardSetting?.gameConfig || {},
    currentGame: state.dashboard?.currentGame || {},
    metricsInfo: state.dashboard?.metricsInfo || {},
  }));
  // 休闲游戏使用专属默认选择器
  const isCasual = currentGame?.data_frame === 'casual';
  const defaultSelector = isCasual ? casualDateComparisonDefaultSelector : mobileDateComparisonDefaultSelector;
  // daily筛选器继承逻辑
  const filterValueRef = useRef<any>(null); // 筛选器值，此处不用state，更新formValue同样会触发组件更新
  // 事件数量低于2时的默认时间
  const defaultStaticsDate = {
    type: 'date',
    filterId: 'statiscDate1',
    name: 'Statistics Date',
    value: getDateDefault({timeType: 'day', timeZone, startNum: 14, endNum: 1}),
  };
  const defaultContrastDate = {
    type: 'date',
    filterId: 'contrastDate1',
    name: `Contrast Date1`,
    value: getDateDefault({timeType: 'day', timeZone, startNum: 28, endNum: 15}),
  };

  // 增加state解决handleReset的闭包问题
  const [defaultDates, setDefaultDates] = useState({
    defaultStaticsDate,
    defaultContrastDate,
  });

  const [statiscDate, setStaticsDate] = useState(defaultStaticsDate);
  const [contrastDate, setContrastDate] = useState([defaultContrastDate]);

  const inputList = [
    {
      key: 'metrics',
      type: "metrics",
      isUseConfig: true,
      /** 后端 page_selector 未配 metrics 时仍展示；key 经下方 useFilterData 第 5 参补进 new_selector */
      allowMissingBackendKey: true,
      // visible: 1,
      default: ['active_users', 'd2'],
      render: renderMetric
    },
    {
      type: "zone",
      key: "zone",
      isUseConfig: true,
      // visible: 0,
      default: [
        "255"
      ]
    },
    {
      type: 'region',
      key: "region",
      isUseConfig: true,
      // visible: 1,
      default: {
        markets: ['255'],
        region_type: 'market'
      },
    },
    {
      type: "channel",
      key: "channel",
      isUseConfig: true,
      // visible: 0,
      default: [
        "255"
      ]
    },
    {
      type: "system",
      key: "system",
      isUseConfig: true,
      // visible: 1,
      default: [
        "255"
      ]
    },
    {
      type: "lang",
      key: "lang",
      isUseConfig: true,
      // visible: 0,
      default: ["255"]
    },

  ];

  const { loading, selector } = useFilterData(
    path,
    'daily',
    defaultSelector,
    true,
    // 第 5 参 → comparison/hooks 的 extraFilterList → useNewSelectorParams，与 filterParamList 去重后并入 new_selector 的 selector_list
    inputList
      .filter((item: any) => item?.allowMissingBackendKey && item?.key)
      .map((item: any) => item.key),
  );
  const { mergedSelector } = useFrontMetricsOverride(config, selector, metricsInfo);
  const { latestDate } = mergedSelector || {};

  const handleConfirm = (value: any) => {
    filterValueRef.current = value;
    setIsReseted(false);

    const comparisonDate = [{
      name: statiscDate?.name,
      type: 'date',
      filterId: statiscDate?.filterId,
      value: statiscDate?.value
    }, ...contrastDate]?.map((item: any) => ({
      name: item?.name,
      start_time: moment(item?.value?.[0])?.format('YYYY-MM-DD'),
      end_time: moment(item?.value?.[1])?.format('YYYY-MM-DD'),
    }));
    filterConfirm && filterConfirm({
      ...value,
      rangeTime: {
        name: statiscDate?.name,
        type: 'date',
        filterId: statiscDate?.filterId,
        value: statiscDate?.value
      },
      comparisonDate,
      timeType: 'Day',
      selector: mergedSelector,
      pagePath: path,
      filterDefaultSelect: defaultSelector
    });
    // 打点，沟通后打点操作放在业务代码的confirm和reset中，不封装在新版本筛选器中
    setBtnPointLog(buttonLogConfig, {
      ...value,
      rangeTime: {
        name: statiscDate?.name,
        type: 'date',
        filterId: statiscDate?.filterId,
        value: statiscDate?.value
      },
      comparisonDate,
      timeType: 'Day'
    });
  };

  const handleReset = (value: any) => {
    filterValueRef.current = value;
    setIsReseted(true);
    const comparisonDate = [
      defaultDates.defaultStaticsDate,
      defaultDates.defaultContrastDate
    ]?.map((item: any) => ({
      name: item?.name,
      start_time: moment(item?.value?.[0])?.format('YYYY-MM-DD'),
      end_time: moment(item?.value?.[1])?.format('YYYY-MM-DD'),
    }));

    filterReset && filterReset({
      ...value,
      rangeTime: defaultDates.defaultStaticsDate,
      comparisonDate,
      timeType: 'Day',
      selector: mergedSelector,
      pagePath: path,
      filterDefaultSelect: defaultSelector
    });
    setStaticsDate(defaultDates.defaultStaticsDate);
    setContrastDate([defaultDates.defaultContrastDate]);
    // 打点，沟通后打点操作放在业务代码的confirm和reset中，不封装在新版本筛选器中
    setBtnPointLog(buttonLogConfig, {
      ...value,
      rangeTime: defaultDates.defaultStaticsDate,
      comparisonDate,
      timeType: 'Day'
    }, true);
  };

  const handleInit = (value: any) => {
    filterValueRef.current = value;
    const comparisonDate = [statiscDate, ...contrastDate]?.map((item: any) => ({
      name: item?.name,
      start_time: moment(item?.value?.[0])?.format('YYYY-MM-DD'),
      end_time: moment(item?.value?.[1])?.format('YYYY-MM-DD'),
    }));
    filterInit?.({
      ...value,
      rangeTime: statiscDate,
      comparisonDate,
      timeType: 'Day',
      selector: mergedSelector,
      pagePath: path,
      filterDefaultSelect: defaultSelector
    });
    setFilterLoading(false);
  };

  // 获取最新2个事件设置默认日期
  useEffect(() => {
    // 防止切换游戏时，会导致默认事件被上一个游戏覆盖
    if(gameConfig?.game_code !== currentGame?.game_code) {
      return;
    }
    const eventList = gameConfig?.season_info?.date || [];
    if (eventList.length >= 2) {
      const newEventList = [...eventList];
      newEventList.sort((a: any, b: any) => {
        // 解决safari浏览器兼容问题
        const aStartData = a.start_date.replace(/-/g, "/");
        const bStartData = b.start_date.replace(/-/g, "/");
        return new Date(bStartData).getTime() - new Date(aStartData).getTime();
      });
      const isEN = getLocale() === 'en-US';

      const dates = {
        defaultStaticsDate: {
          ...defaultDates.defaultStaticsDate,
          name: isEN ? newEventList[0].name : newEventList[0].nameCN,
          value: [
            moment(newEventList[0].start_date),
            moment(newEventList[0].end_date),
          ],
        },
        defaultContrastDate: {
          ...defaultDates.defaultContrastDate,
          name: isEN ? newEventList[1].name : newEventList[1].nameCN,
          value: [
            moment(newEventList[1].start_date),
            moment(newEventList[1].end_date),
          ],
        }
      };

      setDefaultDates(dates);
      setStaticsDate({ ...dates.defaultStaticsDate });
      setContrastDate([dates.defaultContrastDate]);
    }
  }, [gameConfig]);
  
  return <Filter
    filterHideDefaultIsReq={true}
    openSticky={openSticky}
    pageDefaultSelector={defaultSelector}
    path={path}
    outLatestDate={latestDate}
    useFrontFilterConfig={true}
    latestDateType={''}
    value={filterValueRef.current}
    inputList={inputList}
    extraRenderContent={<>
      <DateComparesionExralFilter
        isReseted={isReseted}
        statiscDate={statiscDate}
        contrastDate={contrastDate}
        latestDate={latestDate}
        setContrastDate={setContrastDate}
        setStaticsDate={setStaticsDate} />
    </>}
    onInit={handleInit}
    onConfirm={handleConfirm}
    onReset={handleReset}
    outSelector={mergedSelector}
    loading={loading}
    isHaveFilterSave={isHaveFilterSave}
    // isOutScheme={true}
  >
    {children}
  </Filter>;
};

export default MobileEventComparisonFilter;
